import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';

export const useGetPhoneVerifyStatus = phone => {
  return useQuery({
    queryKey: [QUERY_KEYS.user.phone_verify, phone],
    queryFn: () =>
      userService.phoneVerify().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
